<template>
  <div v-cloak class="learn-detail">
    <div class="breadcrumb">
	<div class="Bread"><Bread :list="breadList" /></div>
      <div class="detail-main">
        <div class="left">
          <el-tabs
            ref="fs"
            v-model="activeName"
            @tab-click="handleClick"
            tab-position="left"
          >
            <!-- 课程介绍 -->
            <el-tab-pane name="one" label="课程介绍">
              <div class="kz">
                <div class="main-left">
                  <div class="title">{{ titles }}</div>
                  <div class="icons-left">
                    <div class="icons-left-children">
                      <div>{{ CategoryName }}</div>
                    </div>

                    <div
                      style="cursor: pointer"
                      @click.stop="collect"
                      class="icons-left-children"
                    >
                      <i
                        :style="{ color: IsCollection ? 'red' : '#666666' }"
                        class="el-icon-collection-tag"
                      ></i>
                      <div :style="{ color: IsCollection ? 'red' : '' }">
                        {{ IsCollection ? "已收藏" : "收藏" }}
                      </div>
                    </div>
                  </div>
                  <!-- 正文 -->
                  <div
                    class="contents"
                    v-html="content"
                    style="margin-bottom: 100px"
                  ></div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane
              :name="'ppt' + index"
              v-for="(ppt, index) in pptss"
              :pptindex="index"
              :pptstatus="ppt.IsPowerPoint"
              :key="ppt.Id"
              :pptid="ppt.Id"
              :label="ppt.Alias"
            >
              <div>
                <iframe
                  class="iframes"
                  style="
                    width: 100%;
                    min-height: 500px;
                    border: none;
                    background-color: #fff;
                  "
                  :src="ppt.Path"
                  frameborder="1"
                ></iframe>
                <div v-if="!ppt.IsVideoComplete" class="watchtime">
                  您需要在线观看
                  <span>{{ ppt.Duration }}</span>
                  分钟，剩余
                  <span>{{ pptwatchtime }}</span>
                  分钟
                </div>
                <div v-else class="watchtime">您已看完</div>
                <div v-if="ppt.Attachments.length > 0" class="accessory">
                  <div class="titles">相关附件</div>
                  <div class="files">
                    <div
                      v-for="files in ppt.Attachments"
                      :key="files.Name"
                      class="files-soon"
                    >
                      <div class="f-left">
                        <img
                          v-if="files.Type == 'Word'"
                          src="../img/word.png"
                          alt=""
                        />
                        <img
                          v-else-if="files.Type == 'PPT'"
                          src="../img/ppt.png"
                          alt=""
                        />
                        <img
                          v-else-if="files.Type == 'ZIP'"
                          src="../img/zip.png"
                          alt=""
                        />
                        <img
                          v-else-if="files.Type == 'PDF'"
                          src="../img/pdf.png"
                          alt=""
                        />
                        <img v-else src="../img/pdf.png" alt="" />
                        <div class="text">
                          <div class="title">{{ files.Name }}</div>
                          <div class="size">
                            格式:{{ files.Type }} 大小:{{ files.Size }}kb
                          </div>
                        </div>
                      </div>
                      <a
                        class="downloads"
                        :download="files.Name"
                        :href="$url + files.Path"
                        ><img src="../img/xz.png" alt
                      /></a>
                      <!-- <div class="downloads"><img src="../img/xz.png" alt="" /></div> -->
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane
              v-for="(sp, index) in videos"
              :key="sp.Id"
              :inds="index"
              :videostatus="sp.IsPowerPoint"
              :vids="sp.Id"
              :vid="sp.Path"
              :label="sp.Alias"
            >
              <div class="videos">
                <div class="v-main">
                  <div
                    class="play prism-player"
                    :id="'J_prismPlayer' + index"
                  ></div>
                  <div v-html="sp.Content" class="play-detail"></div>
                  <div v-if="sp.Attachments.length > 0" class="accessory">
                    <div class="titles">相关附件</div>
                    <div class="files">
                      <div
                        v-for="file in sp.Attachments"
                        :key="file.Name"
                        class="files-soon"
                      >
                        <div class="f-left">
                          <img
                            v-if="file.Type == 'Word'"
                            src="../img/word.png"
                            alt=""
                          />
                          <img
                            v-else-if="file.Type == 'PPT'"
                            src="../img/ppt.png"
                            alt=""
                          />
                          <img
                            v-else-if="file.Type == 'ZIP'"
                            src="../img/zip.png"
                            alt=""
                          />
                          <img
                            v-else-if="file.Type == 'PDF'"
                            src="../img/pdf.png"
                            alt=""
                          />
                          <img v-else src="../img/pdf.png" alt="" />
                          <div class="text">
                            <div class="title">{{ file.Name }}</div>
                            <div class="size">
                              格式:{{ file.Type }} 大小:{{ file.Size }}kb
                            </div>
                          </div>
                        </div>
                        <a
                          class="downloads"
                          :download="file.Name"
                          :href="$url + file.Path"
                          ><img src="../img/xz.png" alt
                        /></a>
                        <!-- <div class="downloads"><img src="../img/xz.png" alt="" /></div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane
              :name="'ppts' + index"
              v-for="(ppt, index) in ppts"
              :pptindex="index"
              :pptstatus="ppt.IsPowerPoint"
              :key="ppt.Id + 1"
              :pptid="ppt.Id"
              :label="ppt.Alias"
            >
              <div>
                <iframe
                  class="iframes"
                  style="
                    width: 1000px;
                    height: 500px;
                    border: none;
                    background-color: #fff;
                  "
                  :src="ppt.Path"
                  frameborder="1"
                ></iframe>
                <div v-if="!ppt.IsVideoComplete" class="watchtime">
                  您需要在线观看
                  <span>{{ ppt.Duration }}</span>
                  分钟，剩余
                  <span>{{ pptwatchtime }}</span>
                  分钟
                </div>
                <div v-else class="watchtime">您已看完</div>
                <div v-if="ppt.Attachments.length > 0" class="accessory">
                  <div class="titles">相关附件</div>
                  <div class="files">
                    <div
                      v-for="files in ppt.Attachments"
                      :key="files.Name"
                      class="files-soon"
                    >
                      <div class="f-left">
                        <img
                          v-if="files.Type == 'Word'"
                          src="../img/word.png"
                          alt=""
                        />
                        <img
                          v-else-if="files.Type == 'PPT'"
                          src="../img/ppt.png"
                          alt=""
                        />
                        <img
                          v-else-if="files.Type == 'ZIP'"
                          src="../img/zip.png"
                          alt=""
                        />
                        <img
                          v-else-if="files.Type == 'PDF'"
                          src="../img/pdf.png"
                          alt=""
                        />
                        <img v-else src="../img/pdf.png" alt="" />
                        <div class="text">
                          <div class="title">{{ files.Name }}</div>
                          <div class="size">
                            格式:{{ files.Type }} 大小:{{ files.Size }}kb
                          </div>
                        </div>
                      </div>
                      <a
                        class="downloads"
                        :download="files.Name"
                        :href="$url + files.Path"
                        ><img src="../img/xz.png" alt
                      /></a>
                      <!-- <div class="downloads"><img src="../img/xz.png" alt="" /></div> -->
                    </div>
                  </div>
                </div>
              </div>
            </el-tab-pane>

            <!-- 我的提问 -->
            <el-tab-pane label="我要出题">
              <div class="idea">
                <el-input
                  v-for="(que, ins) in ques"
                  :key="ins + 9"
                  type="textarea"
                  style="margin-top: 10px"
                  :rows="5"
                  placeholder="在课程学习完成后,请为我们的题库添砖加瓦吧!(至少出2题,才可开启测试)"
                  v-model="questions[ins]"
                ></el-input>
                <div @click.stop="addquestions" class="addquestion">
                  添加更多
                </div>
                <div @click.stop="subquestion" class="subs">确认提交</div>
              </div>
            </el-tab-pane>
            <el-tab-pane
              name="second"
              v-if="examidstatus && questionCount > 1"
              label="测试"
            >
              <div class="test">
                <div v-if="!ExamSubmitId">
                  <div v-show="!tests" class="unfinished">
                    您还未完成课程学习，暂不能参加测试
                    <br />
                    请先看完视频和ppt
                  </div>
                  <div v-show="tests" class="finish">
                    <div class="finishs">您已完成课程学习，可以参加测试</div>
                    <div @click="exams()" class="go">去测试</div>
                  </div>
                </div>

                <!-- 需要状态码判断是否测试完成 -->
                <div v-show="ExamSubmitId" class="result">
                  <!-- <div class="grade">
									<div>{{ examscore }}</div>
									<div style="font-size:16px;">分</div>
								</div> -->
                  <div class="result-time">{{ examt }} 完成测试</div>
                  <div @click="detail()" class="result-detail">测试详情</div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="提问及意见">
              <div v-if="ideastatus" class="idea">
                <el-input
                  type="textarea"
                  @input="ideas"
                  :rows="13"
                  placeholder="请输入您的反馈信息"
                  v-model="textarea"
                ></el-input>
                <div @click.stop="subidea" class="subs">确认提交</div>
              </div>
            </el-tab-pane>
            <el-tab-pane v-if="CertificatePath" label="证件">
              <div class="papers"><img :src="CertificatePath" alt /></div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
    /* 大屏 宽度大于768 */
    @media (min-width: 768px) {
        @import "https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/aliplayer-min.css";

        .Bread {
            width: 1200px;
            margin: 20px auto;
        }

        .learn-detail {
            min-width: 1200px;
            background: #ffffff;
            padding-bottom: 60px;

            .addquestion {
                padding: 5px 10px;
                font-size: 15px;
                width: 100px;
                height: 40px;
                text-align: center;
                line-height: 40px;
                margin-top: 15px;
                border-radius: 5px;
                background-color: rgba(15, 117, 189, 1);
                color: #fff;
            }

            .watchtime {
                width: 365px;
                height: 60px;
                background-color: rgba(255, 229, 143, 1);
                border-radius: 8px;
                margin-top: 15px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 14px;

                span {
                    font-size: 24px;
                    color: #ef5350;
                }
            }

            .breadcrumb {
                width: 1200px;
                margin: 0 auto;
                margin-top: 38px;
                margin-bottom: 65px;
            }

            .detail-main {
                width: 1200px;
                margin: 0 auto;

                .left {
                    .el-tabs--left .el-tabs__item.is-left {
                        text-align: left;
                    }

                    .el-tabs--left .el-tabs__active-bar.is-left {
                        left: 0;
                        right: auto;
                    }

                    .el-tabs__nav-wrap::after {
                        content: "";
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        // width: 100%;
                        // height: 2px;
                        background-color: #ffffff;
                        z-index: 1;
                    }

                    .el-tabs__item {
                        font-size: 14px;
                        font-family: MicrosoftYaHei;
                        padding: 0px 56px 0px 11px;
                    }

                    .is-active {
                        font-size: 14px;
                        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                        // font-weight:bold;
                        color: #0f75bd;
                    }

                    .el-tabs__active-bar {
                        font-weight: bold;
                    }

                    .el-tabs__item:focus.is-active.is-focus:not(:active) {
                        box-shadow: 0 0 2px 2px #ffffff inset;
                        border-radius: 3px;
                    }

                    .main-left {
                        width: 900px;
                        margin-right: 56px;
                        padding-bottom: 25px;
                        box-sizing: border-box;

                        .title {
                            font-size: 18px;
                            font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
                            font-weight: bold;
                            color: rgba(102, 102, 102, 1);
                            margin-bottom: 12px;
                        }

                        .icons-left {
                            width: 180px;
                            margin-bottom: 30px;
                            display: flex;
                            justify-content: space-between;
                            align-items: center;

                            .icons-left-children {
                                display: flex;
                                justify-content: flex-start;
                                align-items: center;

                                div {
                                    font-size: 12px;
                                    font-family: MicrosoftYaHei;
                                    color: rgba(102, 102, 102, 1);
                                    margin-left: 8px;
                                }
                            }
                        }
                    }

                    .kz {
                        display: flex;
                        justify-content: flex-start;
                    }

                    .contents img {
                        width: 100%;
                    }
                }
            }

            .videos {
                // width: 980px;
                width: 100%;
                // height: 800px;
                // margin-left: 50px;

                .v-main {
                    width: 852px;
                    margin: 0 auto;

                    .play {
                        width: 582px;
                        height: 388px;
                        margin: 0 auto;

                        video {
                            width: 100%;
                            height: 100%;

                            .vjs-big-play-button {
                                visibility: hidden; // 隐藏按钮
                            }
                        }
                    }

                    .play-detail {
                        font-size: 14px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: rgba(0, 0, 0, 1);
                        margin-top: 27px;
                        text-indent: 20px;
                        line-height: 35px;
                        margin-bottom: 75px;
                    }

                    .accessory {
                        .titles {
                            width: 87px;
                            height: 26px;
                            border-radius: 13px;
                            font-size: 16px;
                            font-weight: 500;
                            color: rgba(74, 74, 74, 1);
                            border: 1px solid rgba(74, 74, 74, 1);
                            text-align: center;
                            line-height: 26px;
                        }

                        .files {
                            margin-top: 30px;
                            display: flex;
                            justify-content: flex-start;
                            flex-wrap: wrap;

                            .files-soon {
                                // width: 254px;
                                height: 54px;
                                padding-left: 5px;
                                margin-right: 60px;
                                margin-bottom: 25px;
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                background: rgba(245, 247, 250, 1);

                                .f-left {
                                    display: flex;
                                    justify-content: center;
                                    align-items: center;

                                    img {
                                        width: 30px;
                                        height: 30px;
                                    }

                                    .text {
                                        margin-left: 7px;
                                        margin-right: 10px;

                                        .title {
                                            font-size: 14px;
                                            font-family: PingFangSC-Regular, PingFang SC;
                                            font-weight: 400;
                                            color: rgba(0, 0, 0, 1);
                                        }

                                        .size {
                                            font-size: 12px;
                                            font-weight: 400;
                                            color: rgba(118, 118, 118, 1);
                                        }
                                    }
                                }

                                .downloads {
                                    width: 54px;
                                    height: 54px;

                                    img {
                                        width: 100%;
                                        height: 100%;
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .test {
                width: 100%;
                height: 500px;

                .unfinished {
                    font-size: 20px;
                    font-family: MicrosoftYaHei;
                    color: #000000;
                    font-weight: 550;
                    text-align: center;
                    margin-top: 100px;
                }

                .finish {
                    margin-top: 50px;

                    .finishs {
                        font-size: 20px;
                        font-family: MicrosoftYaHei;
                        color: #000000;
                        font-weight: 550;
                        text-align: center;
                    }

                    .go {
                        width: 294px;
                        height: 54px;
                        margin: 100px auto 0px auto;
                        background: rgba(15, 117, 189, 1);
                        text-align: center;
                        line-height: 54px;
                        font-size: 20px;
                        font-family: MicrosoftYaHei;
                        color: rgba(255, 255, 255, 1);
                        cursor: pointer;
                    }
                }

                .result {
                    .grade {
                        font-size: 60px;
                        font-family: MicrosoftYaHei;
                        color: rgba(15, 117, 189, 1);
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                    .result-time {
                        font-size: 20px;
                        font-family: MicrosoftYaHei;
                        color: rgba(118, 118, 118, 1);
                        text-align: center;
                        margin: 16px 0;
                    }

                    .result-detail {
                        width: 294px;
                        height: 54px;
                        margin: 0 auto;
                        background: rgba(15, 117, 189, 1);
                        text-align: center;
                        line-height: 54px;
                        font-size: 20px;
                        font-family: MicrosoftYaHei;
                        color: rgba(255, 255, 255, 1);
                    }
                }
            }

            .idea {
                width: 728px;
                margin: 0 auto;
                padding-bottom: 50px;

                .subs {
                    width: 294px;
                    height: 54px;
                    margin: 40px auto 0px auto;
                    background: rgba(15, 117, 189, 1);
                    text-align: center;
                    line-height: 54px;
                    font-size: 20px;
                    font-family: MicrosoftYaHei;
                    color: rgba(255, 255, 255, 1);
                    cursor: pointer;
                }
            }

            .papers {
                padding-bottom: 100px;
                text-align: center;

                img {
                    width: 514px;
                    height: 354px;
                }

                .title {
                    font-size: 20px;
                    font-family: MicrosoftYaHei;
                    color: rgba(0, 0, 0, 1);
                    margin-bottom: 10px;
                }
            }
        }

        .accessory {
            width: 100%;
            margin-top: 20px;

            .titles {
                width: 87px;
                height: 26px;
                border-radius: 13px;
                font-size: 16px;
                font-weight: 500;
                color: rgba(74, 74, 74, 1);
                border: 1px solid rgba(74, 74, 74, 1);
                text-align: center;
                line-height: 26px;
            }

            .files {
                margin-top: 30px;
                display: flex;
                justify-content: flex-start;
                flex-wrap: wrap;

                .files-soon {
                    // width: 254px;
                    height: 54px;
                    padding-left: 5px;
                    margin-right: 60px;
                    margin-bottom: 25px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    background: rgba(245, 247, 250, 1);

                    .f-left {
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        img {
                            width: 30px;
                            height: 30px;
                        }

                        .text {
                            margin-left: 7px;
                            margin-right: 10px;

                            .title {
                                font-size: 14px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: rgba(0, 0, 0, 1);
                            }

                            .size {
                                font-size: 12px;
                                font-weight: 400;
                                color: rgba(118, 118, 118, 1);
                            }
                        }
                    }

                    .downloads {
                        width: 54px;
                        height: 54px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }
        }
    }
</style>
<script src="https://g.alicdn.com/de/prismplayer/2.7.2/json/json.min.js"></script>
<script src="jquery-1.10.2.min.js"></script>
<!-- <script src="https://g.alicdn.com/de/prismplayer/2.8.2/hls/aliplayer-vod-anti-min.js"></script> -->

<script>
import //   lenandetail,
//   videoplay,
//   studycollects,
//   detailidea,
//   videostatus,
//   pptstatus,
//   getquestions,
//   learnclicksnumber,
//   learntimes,
//   LearningHeartbeat,
"../api.js";

import axios from "axios";
import Bread from "../components/Bread.vue";
export default {
  name: "Learn-detailcopy",
  components: {
    Bread,
  },
  data() {
    return {
      mockres: {
        data: {
          Code: 0,
          Time: "2022-01-15 16:19:17",
          Message: "请求成功",
          Data: {
            AccessTime: "20220115161917819",
            Course: {
              Id: "5389390043046665979",
              Title: "3D按压技术",
              CategoryName: "产品应用",
              Remark: "Weil 3D按压的来源、运行机制及应用",
              Content:
                '<p style="margin-top: 0px; margin-bottom: 0px; line-height: 2em;">美国Weil危重医学研究院是美国最著名的心肺复苏研究中心, 其创始人Dr. Max Weil教授是世界危重医学之父，在他的推荐下，SunLife成为Weil研究院全球战略合作伙伴。&nbsp;</p><p style="margin-top: 0px; margin-bottom: 0px; line-height: 2em;">在2006年，Weil研究院发明了心肺复苏3D按压技术。\n\n3D按压技术的发展是从第一代的单点按压到第二代负荷分布式再到现在的第三代3D按压。</p><p style="margin-top: 0px; margin-bottom: 0px; line-height: 2em;">3D按压技术在临床上有着广范的应用，复苏效果得到了很好的验证与肯定。\n\n其技术原理是胸泵与心泵理论的结合，模拟心脏工作原理，在按压胸腔同时正向压力作用于胸廓四周，而包裹胸腔的方式大大减少释放压力。\n&nbsp;</p><p style="margin-top: 0px; margin-bottom: 0px; line-height: 2em;">在国际SCI文献研究数据表明，第三代3D按压技术的复苏效果明显高于第一代单点按压技术。\n&nbsp;</p><p style="margin-top: 0px; margin-bottom: 0px; line-height: 2em;">3D按压技术的优势表现在有着更好的神经功能表现，最主要体现在按压过程中有着高效的脑部血流灌注，从而能更好的保护神经系统。&nbsp;</p><p style="margin-top: 0px; margin-bottom: 0px; line-height: 2em;">第三代3D按压技术是心肺复苏胸泵和心泵机制的完美结合，动物实验和临床研究证实了其能高效的改善血流动力学效应。</p>',
              IsExam: true,
              IsLimitTime: false,
              ExamId: "5085317340481271203",
              ExistCertificate: true,
              CertificateId: "5262200322245936654",
              IsCollection: false,
              CollectionId: "0",
              IsVideoComplete: true,
              IssueCount: 2,
            },
            Teacher: {
              Picture:
                "https://weiting-develop.oss-cn-shanghai.aliyuncs.com/Course/Teacher/958934466e6d4cbcbeaf75aaaa605c05_1588225519(1).jpg",
              Name: "刘小娜",
              Tag: [],
              Content: "",
            },
            MemberExam: {
              IsExam: true,
            //   ExamSubmitId: "5502884996291770402",
              ExamSubmitId: "",
              SubmitDateTime: "2022.01.15 16:13",
              CertificatePath:
                "https://ranwei-develop.oss-cn-shanghai.aliyuncs.com/Course/Certificate/Result/6c96ac48baab42c7bba6a556acba9ee9_SL111003.jpg.jpg",
            },
            Videos: [
              {
                Id: "4780872222380421428",
                Title: "3D按压介绍视频_MCC-E",
                Sort: 1,
                Alias: "3D按压",
                Duration: null,
                IsPowerPoint: false,
                Path: "5ea6f23a916f4000b51405ed5cb9383a",
                Remark: "3D按压介绍视频_MCC-E",
                Content: "<p>3D按压介绍视频_MCC-E</p>",
                IsVideoComplete: false,
                Attachments: [
                  {
                    Id: "4695289750062889157",
                    Name: "3D按压技术：MCCSCC",
                    Type: "PPT",
                    Size: 29616.0,
                    Source: 1,
                    Path: "/Content/Upload/Course/Attachment/5389390043046665979/5045240608837360297.ppt",
                  },
                ],
              },
              {
                Id: "5736734609498952256",
                Title: "3D按压技术：MCCSCC",
                Sort: 3,
                Alias: "我是PPT",
                Duration: 1,
                IsPowerPoint: true,
                Path: "https://vip.ow365.cn/?i=21419&furl=https%3a%2f%2fweiting-develop.oss-cn-shanghai.aliyuncs.com%2fCourse%2fLearning%2f193bf5a73e11464086f93d2011282b19_3D%e6%8c%89%e5%8e%8b%e6%8a%80%e6%9c%af%ef%bc%9aMCCSCC.ppt&p=1&ssl=1",
                Remark: "3D按压技术：MCCSCC",
                Content: "<p>3D按压技术：MCCSCC</p>",
                IsVideoComplete: true,
                Attachments: [
                  {
                    Id: "5236414543319173953",
                    Name: "3D按压技术：MCCSCC.ppt",
                    Type: "PPT",
                    Size: 3977.0,
                    Source: 1,
                    Path: "/Content/Upload/Course/Attachment/5389390043046665979/5235109260875086296.ppt",
                  },
                ],
              },
            ],
          },
        },
      },
      paths: "", //上一级路由地址
      title: "", //上一级路由名称
      textarea: "", //意见反馈
      ideastatus: false,
      datas: "",
      id: "", //课程id
      titles: "", //标题
      CategoryName: "", //beizhu

      content: "",
      teachername: "",
      tags: [],
      teacherimg: "",
      teachercontent: "",
      videos: [],
      pptss: [],
      ppts: [], //ppt数组
      myPlayer: "",
      ids: [], //视屏标签id名
      vlength: "", //视频个数
      tests: false,
      vids: "", //阿里视频id
      examscore: "", //考试分数
      examt: "", //完成考试时间
      videoId: "", // 视频播放Id
      ExamSubmitId: "", //考试结果id
      player: null, // 播放器对象
      videoMeta: {},
      CurrentTime: null,
      fetch_static: false,
      CertificatePath: "", //证书是否显示
      examidstatus: "", //测试是否显示
      IsCollection: "", //是否收藏
      pptduraction: [], //ppt时间数组
      ppttimer: "", //ppt定时器
      pptids: [], //ppt看过数组
      pptwatchtime: "", //ppt剩余观看时间
      activeName: "one",
      label: "",
      IsLimitTime: "", //是否必须看完才能测试
      courseIsVideoComplete: "", //是否全部看完
      CategoryName: "",
      questions: [], //提的问题
      questionCount: "", //已提问题的次数
      ques: [1, 2], //输入框个数
      clicks: {}, //次数数组
      opentime: "", //进入时间
      firsts: false, //xianxianshi
      fir: false,
      timer: null,
      breadList: [
        { name: "创作训练营", path: "/creation/index" },
        { name: "正文", path: "/creation/detail" },
      ],
    };
  },

  created() {
    let path = this.$route.query.paths;
    let titles = this.$route.query.name;
    console.log(this.GetQueryString("id"));
    let id = this.GetQueryString("id");

    this.paths = path;
    this.title = titles;
    this.id = id;
    localStorage.setItem("kid", id); //课程id

    let second = localStorage.getItem("second");
    this.details();
    if (second == 1) {
      this.activeName = "second";
    }
  },
  beforeRouteLeave(to, from, next) {
    localStorage.removeItem("second");
    let token = localStorage.getItem("AccessToken");
    if (token) {
      let kid = this.id;
      let VideoCounts = this.clicks;

      console.log(VideoCounts);
      let datas = {
        Token: token,
        CourseId: kid,
        VideoCount: VideoCounts,
        Source: "pc",
      };
      let datass = {
        Token: token,
        CourseId: kid,
        AccessTime: this.opentime,
        Source: "pc",
      };

      learnclicksnumber(datas).then(() => {});
      learntimes(datass).then(() => {});
    }

    next();
  },

  mounted() {
    // console.log(firsts)
    // this.details();
    this.timer = setInterval(() => {
      this.jcuser();
    }, 120000);
  },

  destroyed() {
    clearInterval(this.timer);
    clearInterval(this.ppttimer);
    this.ppttimer = null;
    this.timer = null;
    this.pptwatchtime = "";
  },

  methods: {
    GetQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substr(1).match(reg);
      var context = "";
      if (r != null) context = r[2];
      reg = null;
      r = null;
      return context == null || context == "" || context == "undefined"
        ? ""
        : context;
    },

    // 去测试
    exams() {
      this.$router.push({
        path: "/Examcopy",
        query: {
          paths: "/creation/detail",
          name: "正文",
        },
      });
    },
    // 测试详情
    detail() {
      let subid = this.ExamSubmitId; //考试结果id
      this.$router.push({
        path: "/Exam-detail",
        query: {
          paths: "/creation/detail",
          name: "正文",
          ExamSubmitId: subid,
        },
      });
    },

    // 添加更多提问
    addquestions() {
      let num = this.ques.length + 1;
      this.ques.push(num);
    },

    // 检测用户
    jcuser() {
      let token = localStorage.getItem("AccessToken") || "";
      let kid = this.id;
      let datas = {
        Token: token,
        CourseId: kid,
      };
      LearningHeartbeat(datas).then(() => {});
    },

    // 提交问题内容
    subquestion() {
      console.log("000-----");
      console.log(this.questions);
      let id = this.id;
      let token = localStorage.getItem("AccessToken");
      let ids = JSON.parse(localStorage.getItem(`${id}`)) || []; //视屏看完的id数组
      let pptids = JSON.parse(localStorage.getItem(`ppt${id}`)) || []; //ppt看完的id数组
      let vlength = this.vlength || 0; //视频总个数
      let pptlength = this.ppts.length || 0; //ppt总个数
      let sumlength = vlength + pptlength; //所有的个数
      let looklength = ids.length + pptids.length; //看完的总个数
      let Content = this.questions;
      let questionCount = this.questionCount; //已提问题次数

      if (!token) {
        this.$message.error("需要您先登录哦");
        return;
      }
      if (!this.courseIsVideoComplete && this.IsLimitTime) {
        this.$message.error("需要您看完所有视频和PPT");
        return;
      }
      if (
        !this.courseIsVideoComplete &&
        sumlength != looklength &&
        this.IsLimitTime
      ) {
        this.$message.error("需要您看完所有视频和PPT");
        return;
      }

      if (questionCount == 0 && this.questions.length < 2) {
        this.$message.error("至少提问2个问题");
        return;
      }

      if (Content.length < 1) {
        this.$message.error("问题内容不能为空");
        return;
      }

      let datas = {
        Token: token,
        CourseId: id,
        Content: Content,
        Source: "pc",
      };

      getquestions(datas).then((res) => {
        // console.log(res)
        if (res.data.Code == 0) {
          this.$message({
            message: "提问成功",
            type: "success",
          });
          this.questions = [];
          this.questionCount = res.data.Data.IssueCount;
        }
      });
    },

    // 收藏
    collect() {
      if (!this.IsCollection) {
        let token = localStorage.getItem("AccessToken") || "";
        let id = this.id;
        let datas = {
          Token: token,
          CourseId: id,
          Source: "pc",
        };
        studycollects(datas).then((res) => {
          if (res.data.Code == 0) {
            this.IsCollection = true;
            this.$message({
              message: "收藏成功",
              type: "success",
            });
          } else {
            this.$message.error(res.data.Message);
          }
        });
      }
    },

    // 课程详情
    details() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "#0000000",
      });
      let that = this;
      let id = that.id;
      let token = localStorage.getItem("AccessToken") || "";
      let datass = {
        id: id,
        token: token,
        source: "pc",
        language: 1,
      };
      // lenandetail(datass).then(res => {
      // console.log(res);
      let res = this.mockres;
      if (res.data.Data) {
        let respornes = res.data.Data;
        let vi = respornes.Videos;
        if (vi.length > 0) {
          // console.log(vi[0].IsPowerPoint)
          this.firsts = vi[0].IsPowerPoint;
          // console.log(this.firsts)

          this.datas = respornes;
          // 筛选视频
          let v = [];
          v = vi.filter((items) => {
            console.log(items.IsPowerPoint);
            return items.IsPowerPoint == false;
          });

          let compares = function (x, y) {
            //比较函数
            let xs = x.Sort;
            let ys = y.Sort;
            if (xs < ys) {
              return -1;
            } else if (xs > ys) {
              return 1;
            } else {
              return 0;
            }
          };

          this.videos = v.sort(compares);
          // console.log(this.videos)
          // 筛选ppt
          let pp = [];
          pp = vi.filter((items) => {
            return items.IsPowerPoint == true;
          });

          let compare = function (x, y) {
            //比较函数
            let xs = x.Sort;
            let ys = y.Sort;
            if (xs < ys) {
              return -1;
            } else if (xs > ys) {
              return 1;
            } else {
              return 0;
            }
          };

          this.ppts = pp.sort(compare);
          this.pptss = pp.sort(compare);
          // console.log(this.ppts)
        }

        //取出ppt时间数组pptduraction
        let pptarry = [];
        let ppt = this.ppts;
        pptarry = ppt.map((items) => {
          return items.Duration;
        });
        this.pptduraction = pptarry;
        this.opentime = res.data.Time;

        this.vlength = this.videos.length;
        this.titles = respornes.Course.Title;
        this.CategoryName = respornes.Course.CategoryName;
        this.IsCollection = respornes.Course.IsCollection;
        this.ExamSubmitId = respornes.MemberExam.ExamSubmitId;
        this.examscore = respornes.MemberExam.ExamScore;
        this.examt = respornes.MemberExam.SubmitDateTime;
        this.content = respornes.Course.Content;
        this.IsLimitTime = respornes.Course.IsLimitTime;
        this.CategoryName = respornes.Course.CategoryName;
        this.questionCount = respornes.Course.IssueCount;
        this.courseIsVideoComplete = respornes.Course.IsVideoComplete;
        localStorage.setItem("examid", respornes.Course.ExamId); //考试id
        this.examidstatus = respornes.Course.ExamId;
        this.teachername = respornes.Teacher.Name;
        this.tags = respornes.Teacher.Tag;
        this.CertificatePath = respornes.MemberExam.CertificatePath;
        this.teacherimg = respornes.Teacher.Picture;
        this.teachercontent = respornes.Teacher.Content;

        this.shows();

        loading.close();
      } else {
        loading.close();
      }
      // });
    },

    shows() {
      if (this.firsts) {
        this.ppts = [];
      } else {
        this.pptss = [];
      }
    },

    // 视屏
    studyvideo(vid, index) {
      console.log("ppppppp--------+++++");
      console.log(vid);
      console.log(index);
      let that = this;

      let vids = vid;
      let datas = {
        videoId: vids,
        source: "pc",
        language: 1,
      };
      let response = {
        data: {
          Code: 0,
          Time: "2022-01-15 16:42:03",
          Message: "请求成功",
          Data: {
            VideoMeta: {
              CoverURL:
                "https://aliyunvod.ran-wei.cn/5ea6f23a916f4000b51405ed5cb9383a/snapshots/4fe82170a7e9447d92c7db17c88ab79e-00005.jpg",
              Duration: 114.7307,
              Status: "Normal",
              Title: "3D按压介绍视频_MCC-E",
              VideoId: "5ea6f23a916f4000b51405ed5cb9383a",
            },
            PlayAuth:
              "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",
          },
        },
      };
      //   videoplay(datas).then((response) => {
      if (response.data.Code === 0) {
        if (that.player) {
          that.player.pause();
        }

        that.videoId = response.data.Data.VideoMeta.VideoId;
        let playAuth = response.data.Data.PlayAuth;
        that.videoMeta = response.data.Data.VideoMeta;
        that.player = that.doPlayer(this.videoId, playAuth, index);
      }
      //   });
    },

    doPlayer(vid, playAuth, index) {
      this.player = new Aliplayer(
        {
          id: "J_prismPlayer" + index, // 播放器外层容器的dom元素id。
          vid: vid, // 视频id
          playauth: playAuth, // 播放凭证
          qualitySort: "asc",
          format: "mp4",
          mediaType: "video",
          language: "zh-cn", // 如果未设置，则采用浏览器语言。 可选值为‘zh- cn’、‘en - us’或其它值。
          encryptType: 1, // 加密类型，播放点播私有加密视频时，设置值为1，默认值为0。
          width: "100%",
          height: "388px",
          autoplay: false, // 自动播放
          isLive: false, // 播放内容是否为直播，直播时会禁止用户拖动进度条。
          rePlay: false, // 循环播放
          playsinline: true, // H5是否内置播放
          preload: true, // 自动加载，目前仅h5可用
          controlBarVisibility: "hover",
          useH5Prism: true, // 使用H5播放器
          diagnosisButtonVisible: false, // 是否显示检测按钮
        },

        function (player) {
          // document.getElementById(`'J_prismPlayer'${index - 1}`).style.width = "100%"
          // document.getElementById(`'J_prismPlayer'${index - 1}`).style.height = "488px"
          console.log("The player is created");
        }
      );
      this.vids = vid;
      // 播放结束时执行
      this.player.on("ended", this.endedHandle);

      return this.player;
    },
    endedHandle() {
      let vid = this.vids;

      this.plays(vid);
    },

    // 视频ppt看完
    videoover(id) {
      let token = localStorage.getItem("AccessToken");
      if (token) {
        let datas = {
          Token: token,
          CourseId: id,
          Source: "pc",
        };
        videostatus(datas).then((res) => {
          this.courseIsVideoComplete = true;
          console.log(res.status);
        });
      }
    },

    // 存视频记录
    plays(e) {
      console.log(e);
      let id = this.id;
      let mid = localStorage.getItem(`${id}`);
      let lengths = this.vlength;
      let sumlength = this.vlength + this.ppts.length; //所以视频和ppt的总个数
      let pptids = JSON.parse(localStorage.getItem(`ppt${id}`)); //已看过的ppt数组
      let pptidss = pptids ? pptids.length : 0;
      if (mid) {
        let ids = JSON.parse(localStorage.getItem(`${id}`));
        ids.push(e);
        let myArray = [...new Set(ids)];
        localStorage.setItem(`${id}`, JSON.stringify(myArray));
        localStorage.setItem(`videostatus`, JSON.stringify(myArray));

        let oversumlength = pptidss + myArray.length; //已经看过的视频和ppt的个数
        console.log(sumlength);
        console.log(oversumlength);
        if (sumlength == oversumlength) {
          //全部看完上传

          this.videoover(id);
        }
      } else {
        this.ids.push(e);
        let myArray = [...new Set(this.ids)];
        localStorage.setItem(`${id}`, JSON.stringify(myArray));
        localStorage.setItem(`videostatus`, JSON.stringify(myArray));
        let pptids = JSON.parse(localStorage.getItem(`ppt${id}`)); //已看过的ppt数组

        let oversumlength = pptidss + myArray.length; //已经看过的视频和ppt的个数

        if (sumlength == oversumlength) {
          //全部看完上传

          this.videoover(id);
        }
      }
    },

    //ppt计时器
    realtimes(time, index, pptid) {
      console.log(time);
      console.log(index);
      console.log(pptid);
      this.pptwatchtime = time;
      let pps = this.firsts ? this.pptss : this.ppts;
      this.ppttimer = setInterval(() => {
        time--;

        this.pptwatchtime = time;
        if (time <= 0) {
          clearInterval(this.ppttimer);
          this.pptplays(index);
          this.$set(pps[index], "IsVideoComplete", true);
          this.uploadppt(pptid);
        }
      }, 60000);
    },

    // 上传一个一个ppt看完的
    uploadppt(pptid) {
      let id = this.id;
      let token = localStorage.getItem("AccessToken");

      if (token) {
        let ppts = [];
        ppts.push({
          Token: token,
          CourseId: id,
          VideoId: pptid,
          Source: "pc",
        });

        let datas = {
          model: ppts,
        };
        pptstatus(datas).then((res) => {
          console.log(res.status);
        });
      } else {
        let pp = JSON.parse(localStorage.getItem(`ppttoken`)) || [];
        pp.push({
          Token: "",
          CourseId: id,
          VideoId: pptid,
          Source: "pc",
        });
        localStorage.setItem(`ppttoken`, JSON.stringify(pp));
      }
    },

    // 存ppt记录
    pptplays(e) {
      console.log(e);
      let id = this.id;
      let vlength = this.vlength; //视屏的总个数
      let mid = localStorage.getItem(`ppt${id}`); //ppt数组名字
      let lengths = this.ppts; //ppt的总个数
      let sumlength = this.vlength + this.ppts.length; //所以视频和ppt的总个数
      let videoarry = JSON.parse(localStorage.getItem(`${id}`)); //已经看过的视频数组id
      let videoarrys = videoarry ? videoarry.length : 0;

      if (mid) {
        let pptids = JSON.parse(localStorage.getItem(`ppt${id}`));
        pptids.push(e);
        let myArray = [...new Set(pptids)];
        localStorage.setItem(`ppt${id}`, JSON.stringify(myArray)); //把这次的合并到之前看过的
        localStorage.setItem(`pptstatus`, JSON.stringify(myArray));

        let oversumlength = videoarrys + myArray.length; //已经看过的视频和ppt的个数

        if (sumlength == oversumlength) {
          //全部看完上传

          this.videoover(id);
        }
      } else {
        this.pptids.push(e);
        let myArray = [...new Set(this.pptids)];
        localStorage.setItem(`ppt${id}`, JSON.stringify(myArray));
        localStorage.setItem(`pptstatus`, JSON.stringify(myArray));

        let oversumlength = videoarrys + myArray.length; //已经看过的视频和ppt的个数

        if (sumlength == oversumlength) {
          //全部看完上传

          this.videoover(id);
        }
      }
    },

    // 存点击次数
    clicksnumber(id) {
      let datas = this.clicks;
      if (datas[id]) {
        datas[id] = datas[id] + 1;
      } else {
        datas[id] = 1;
      }
      this.clicks = datas;
    },

    //点击左导航
    handleClick(event) {
      // console.log(event)
      clearInterval(this.ppttimer);
      this.ppttimer = null;
      this.pptwatchtime = "";
      console.log(this.ppts.length);
      // 点击的视屏
      if (event.$attrs.videostatus == false) {
        console.log("视屏------");
        console.log(this.vlength);
        let vid = event.$attrs.vid;
        let index = event.$attrs.inds;
        this.studyvideo(vid, index);

        this.clicksnumber(event.$attrs.vids);
        // this.player.dispose();
      }

      if (event.label == "测试") {
        console.log("测试");
        let id = this.id;
        let ids = JSON.parse(localStorage.getItem(`${id}`)) || []; //视屏看完的id数组
        let pptids = JSON.parse(localStorage.getItem(`ppt${id}`)) || []; //ppt看完的id数组

        let vlength = this.vlength || 0; //视频总个数
        let pptlength = this.ppts.length || 0; //ppt总个数
        let sumlength = vlength + pptlength; //所有的个数
        let looklength = ids.length + pptids.length; //看完的总个数

        if (this.IsLimitTime) {
          //必须全部看完才能测试
          if (this.courseIsVideoComplete) {
            this.tests = true;
          } else if (sumlength == looklength) {
            this.tests = true;
          } else {
            this.tests = false;
          }
        } else {
          //不必全部看完可以测试
          this.tests = true;
        }
      }

      // 点击的ppt
      if (event.$attrs.pptstatus) {
        let pps = this.firsts ? this.pptss : this.ppts;
        let index = event.$attrs.pptindex;
        let time = pps[index].Duration; //点击的ppt时间
        let pptid = pps[index].Id; //pptid

        if (!pps[index].IsVideoComplete) {
          // 没看完
          let m = time;

          this.realtimes(m, index, pptid);
        }
        this.clicksnumber(event.$attrs.pptid);
      }

      if (event.label == "提问及意见") {
        this.textarea = "";
        let token = localStorage.getItem("AccessToken");
        if (!token) {
          this.$confirm("此操作需要您登录，是否去登录?", "提示", {
            confirmButtonText: "去登录",
            cancelButtonText: "取消",
          })
            .then(() => {
              this.$router.push("/login");
            })
            .catch(() => {
              console.log("取消");
            });
        } else {
          this.ideastatus = true;
        }
      }

      // 好了放开
      if (event.index != this.vlength) {
        this.player.dispose();
      }
    },
    // 意见反馈
    ideas(e) {
      this.textarea = e;
      this.fetch_static = false;
    },
    // 提交意见
    subidea() {
      if (this.fetch_static) {
        return;
      } else {
        this.fetch_static = true;
      }

      if (this.fetch_static) {
        let token = localStorage.getItem("AccessToken");

        let datas = {
          CourseId: this.id,
          Token: token,
          Content: this.textarea,
          Source: "pc",
        };
        detailidea(datas).then((res) => {
          if (res.data.Code == 0) {
            this.fetch_static = true;
            this.$message({
              message: "反馈成功",
              type: "success",
            });
            this.textarea = "";
          } else {
            this.$message.error(res.data.Message);
            this.fetch_static = false;
          }
        });
      }
    },
  },
};
</script>
